import React, { useEffect, useState } from "react";
import { retornaEmail, setMemoria } from "./auxiliar";
import { Modal, Container, FormCheck, Row, Col, Button } from "react-bootstrap";
import api from "../services/api";

export default function Perfil( props ) {
  const nomeParticipante = localStorage.getItem("NomeParticipante");
  const email = retornaEmail();
  const login = localStorage.getItem("Login");
  const [receberEmail, setReceberEmail]= useState(false);
  const [pessoa, setPessoa] = useState([]);

  useEffect(() => {
    async function loadPessoa() {
      if (email.indexOf("@") > 1) {
        const response = await api.get(`/api/pessoa/${email}/publico`);
        setPessoa(response.data[0]);
      }
    }
    loadPessoa();
  }, [email]);

  useEffect(() => {
    async function loadReceberEmail() {
      if (pessoa.ST_RECEBER_EMAIL === "S"){
        setReceberEmail(true);
      }
    }
    loadReceberEmail();
  }, [pessoa]);

  function handleSair(){
    if (login === "GOVBR"){
      props.onHide();
      window.location = "/Logout";
    } else {
      setMemoria("","", false);
      window.location = "/";
    }
  }
  async function handleSalvar(){
    var receberEmailAux = "N";
    if (receberEmail){
      receberEmailAux = "S";
    }
    const data = { 
      'idPessoa': pessoa.ID_PESSOA,
      'receberEmail': receberEmailAux
    };
    await api.put(
      `/api/pessoa/ReceberEmail`,
      data);
    props.onHide();
  }

  return (
    <>
      <div>
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter" animation={true}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Identificação do Participante
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
              <Row className="show-grid">
                <Col sm={12}>
                    <h3>{nomeParticipante}</h3>
                </Col>
              </Row>
              <Row className="show-grid">
                <Col sm={12}>
                    <h4>{email}</h4>
                </Col>
              </Row>
              <Row className="show-grid">
                <Col sm={12}>
                    <h4>Identificado pelo <strong>{login}</strong></h4>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <FormCheck>
                    <FormCheck.Input type={'checkbox'} 
                      className="receberEmail"
                      defaultChecked={receberEmail} 
                      onChange={event =>setReceberEmail(!receberEmail)}/>
                    <FormCheck.Label>Receber informações sobre Participações Sociais da ANA?</FormCheck.Label>
                  </FormCheck>
                </Col>
              </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleSair}>Sair</Button>
          <Button variant="success" onClick={handleSalvar}>Salvar</Button>
          <Button variant="secondary" onClick={props.onHide}>Cancelar</Button>
        </Modal.Footer>
      </Modal>
      </div>
    </>
  );
}